import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Control } from 'shared/components/fields/control';
import { SettingFullRow } from 'z3k-settings/components/material-utils/settings-card';
import { MultipleSelectionTable, } from 'z3k-settings/components/material-utils/multiple-selection-table/multiple-selection';
import { useCallback, useContext, useMemo, useState } from 'react';
import { MaterialRadioGroupControl } from 'shared/components/fields';
import { useEditingProps, useGetZ3kObject, } from 'z3k-settings/components/utils/unpack-props';
import { select_elements_options, selectAnalogOutputOptions, selectPumpsOptions, selectRelayControlsOptions, selectThreewayTapsOptions, } from 'z3k-settings/components/utils/z3k-selectors';
import { Z3KSettings, Z3KSettingsEditor } from 'z3k-settings/provider/types';
import { SelectForTypeGroup } from 'z3k-settings/components/mqtt-topics/select_for_type_group';
import { MQTTTopic } from 'z3k-parser/model/z3k-config/57-mqtt';
const z3k_name = 'mqtt_topics';
export const ComponentObjectForTopic = () => {
    const { config } = useContext(Z3KSettingsEditor);
    const item = useGetZ3kObject(z3k_name);
    const initialState = useMemo(() => MQTTTopic.isTopicSelectTypeObject(item), [item]);
    const id = item.id;
    const [flagToSelectObject, setFlagToSelectObject] = useState(initialState);
    const paramsTypeEditingProps = useEditingProps(id, z3k_name, 'type_object');
    const paramsListEditingProps = useEditingProps(id, z3k_name, 'link_list');
    const { device_spec } = useContext(Z3KSettings);
    const relays = selectRelayControlsOptions(config);
    const pumps = selectPumpsOptions(config);
    const taps = selectThreewayTapsOptions(config);
    const analog_output = selectAnalogOutputOptions(config);
    const elements_options = [
        ...select_elements_options(config, device_spec),
        relays,
        pumps,
        taps,
        analog_output,
    ];
    const object_options = useMemo(() => [
        {
            label: 'По списку объектов',
            value: 'link_list',
            help_id: null,
        },
        {
            label: 'По типу объектов',
            value: 'type_object',
            help_id: null,
        },
    ], []);
    const object = useMemo(() => (flagToSelectObject ? 'type_object' : 'link_list'), [flagToSelectObject]);
    const object_radio_field = useCallback((input_props) => (_jsx(MaterialRadioGroupControl, { control_values: object_options, ...input_props })), [object_options]);
    const onChangeObject = useCallback((new_perm) => {
        setFlagToSelectObject(!flagToSelectObject);
        if (new_perm === 'type_object') {
            paramsListEditingProps.onChange([]);
        }
        else {
            paramsTypeEditingProps.onChange(255);
        }
    }, [flagToSelectObject]);
    const multipleSelectionTableOptions = useMemo(() => {
        return [
            {
                title: 'Выбрать доступные объекты',
                help_id: '',
                options: elements_options,
                z3k_field: 'link_list',
            },
        ];
    }, [item, elements_options]);
    return (_jsxs(_Fragment, { children: [_jsx(Control, { label: "\u0421\u043F\u043E\u0441\u043E\u0431 \u043F\u0443\u0431\u043B\u0438\u043A\u0430\u0446\u0438\u0438:", value: object, onChange: onChangeObject, field: object_radio_field, validation_result: null, validation_warnings_result: null }), _jsx(SettingFullRow, { children: flagToSelectObject ? (_jsx(SelectForTypeGroup, {})) : (_jsx(MultipleSelectionTable, { elements: multipleSelectionTableOptions, z3k_name: z3k_name, notification: false, name_second_column: 'Объекты' })) })] }));
};
